import { Pressable } from "@-/com.npmjs.react-native";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import {
  ToolbarGlassSurface,
  useToolbarGridMetrics,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import {
  useLearnMapModeSelector,
  useLeaveLearnMap,
} from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.map-mode";

/**
 * Leaves Learn's map for the cards: the glass circle the More menu turns into while the map is
 * showing, the size of the More trigger and the app shell's back control. On the map home there
 * are no cards to go back to yet, so it is Learn (the Learn tab's icon), which opens them.
 */
export function LearnMapBackButton() {
  const { diameter } = useToolbarGridMetrics();
  const leaveMap = useLeaveLearnMap();
  const isMapHome = useLearnMapModeSelector((mode) => mode.isMapHomeControl) ?? false;
  return (
    <ToolbarGlassSurface style={{ height: diameter, width: diameter }}>
      <Pressable
        accessibilityLabel={isMapHome ? "Learn" : "Back to cards"}
        accessibilityRole="button"
        className="size-full items-center justify-center"
        hitSlop={8}
        onPress={leaveMap}
        testID={isMapHome ? "learn-map-learn-button" : "learn-map-back-button"}
      >
        {isMapHome ? (
          <Icon className="text-foreground" name="MdSchool" size={22} />
        ) : (
          <Icon className="text-foreground" name="FiChevronLeftBold" size={24} />
        )}
      </Pressable>
    </ToolbarGlassSurface>
  );
}
